export default {"src":"/_next/static/media/xpr.f17df333.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};